import ErrorActionsEnums from './ErrorActionsEnums';

const defaultState = {
    errorMessage: null,
    errorStatus: null
};

function ErrorReducer(state = defaultState, action) {
    switch (action.type) {
        case ErrorActionsEnums.ERROR_OPEN_MODAL:
            return {
                ...state,
                errorMessage: action.errorMessage,
                errorStatus: action.errorStatus
            };
        case ErrorActionsEnums.ERROR_CLOSE_MODAL:
            return {
                ...state,
                errorMessage: null,
                errorStatus: null
            };
        default:
            return state;
    }
}

export default ErrorReducer;



// WEBPACK FOOTER //
// ./src/store/error/ErrorReducer.js